import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import BranchList from '../components/branchList/BranchList';
import { compose, lifecycle } from 'recompose';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import { fetchBranches } from '../store/actions/branches';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.branches,
        openBranch: (index) => {
            let selectedBranch = state.branches.branches[index];
            ownProps.history.push(`/customers/${ownProps.customerId}/${selectedBranch.id}`)
        }
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const {customerId} = ownProps;
    return {
        fetchBranches: () => dispatch(fetchBranches(customerId))
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchBranches();
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent,
)(BranchList);






// WEBPACK FOOTER //
// ./src/containers/BranchListContainer.js